var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectCategoryLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 36984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 91",
    d: "M20.1922 16H1.3399C1.18741 16 1.09664 15.8407 1.1846 15.7161C1.88226 14.7281 4.64775 11.5 11 11.5C17.3841 11.5 19.7831 14.7605 20.3556 15.7308C20.4292 15.8554 20.337 16 20.1922 16Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 92",
    d: "M11 11V4M11 4C12.324 1.95999 13.6687 1.17915 15.5 1H18.7654C18.8885 1 18.9824 1.11029 18.9632 1.23188C18.6295 3.34911 18.3951 5.01748 15.5 5.5C12.5 6 9 6 7 5.5C5.06476 5.01619 3.57499 3.56957 3.0495 1.23713C3.02189 1.11458 3.11655 1 3.24217 1H6.5C8.741 1.17905 9.66037 1.96138 11 4Z",
    stroke: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCategoryLaunch);
export default __webpack_public_path__ + "static/media/project-category-launch.c83de9f9.svg";
export { ForwardRef as ReactComponent };